import Vue from 'vue'
import router from '@/router'
import appMenu from "@/_nav";
import {
    authNav
} from "@/shared/auth/temAcesso";

const state = {
    token: null,
    expirationDate: null,
    usuario: {
        usuarioId: null,
        nome: null,
        email: null,
        login: null,
        aspl: null
    },
    menu: []
}

const mutations = {

    SET_USUARIO(state, auth) {
        let decodedToken = Vue.$jwt.decode(auth.token)
        state.token = auth.token
        state.usuario.usuarioId = decodedToken.usrId
        state.usuario.nome = decodedToken.usrName
        state.usuario.login = decodedToken.usrLogin
        state.usuario.email = decodedToken.usrEmail
        state.usuario.asplFlag = decodedToken.usrAsplFlag
        state.expirationDate = auth.time
    },

    REMOVE_USUARIO(state) {
        state.token = null
        state.expirationDate = null
        state.usuario.usuarioId = null
        state.usuario.nome = null
        state.usuario.login = null
        state.usuario.email = null
        state.usuario.asplFlag = null
    },

    ATUALIZAR_MENU(state) {
        state.menu = authNav(appMenu.items)
    }
}

const actions = {

    // setLogoutTimer({
    //     commit
    // }, expirationTime) {
    //     setTimeout(() => {
    //         commit('REMOVE_USUARIO')
    //     }, expirationTime)
    // },

    login({
        commit,
        dispatch,
        state
    }, authData) {
        let tFim = new Date(authData.expiraEm)
        let tInicio = new Date(authData.criadoEm)
        let tempoExpirar = tFim.getTime() - tInicio.getTime()
        let localExpiraEm = new Date(Date.now() + tempoExpirar)
        commit('SET_USUARIO', {
            token: authData.accessToken,
            time: localExpiraEm
        })
        localStorage.setItem('token', authData.accessToken)
        localStorage.setItem('userId', state.usuario.usuarioId)
        localStorage.setItem('localExpirationDate', localExpiraEm.toISOString())
        // dispatch('setLogoutTimer', tempoExpirar)
        dispatch('atualizarMenu')
    },

    logout({
        dispatch
    }) {
        dispatch('removerUsuario')
    },

    removerUsuario({
        commit
    }) {
        commit('REMOVE_USUARIO')
        localStorage.removeItem('token')
        localStorage.removeItem('userId')
        localStorage.removeItem('expirationDate')
        router.push('/login')
    },

    tryAutoLogin({
        commit,
        dispatch
    }) {
        const token = localStorage.getItem('token')
        if (!token) {
            return
        }
        const expirationDate = new Date(localStorage.getItem('localExpirationDate'))
        const now = new Date()
        if (now >= expirationDate) {
            dispatch('removerUsuario')
            return
        }
        commit('SET_USUARIO', {
            token: token,
            time: expirationDate
        })
        dispatch('atualizarMenu')
    },

    atualizarMenu({
        commit
    }) {
        commit('ATUALIZAR_MENU')
    }
}

const getters = {

    usuario(state) {
        return state.usuario
    },

    estaAutenticado(state) {
        return state.token !== null
    },

    deveAtualizarSenha(state) {
        return state.usuario.asplFlag === 'True'
    },

    getToken(state) {
        return state.token
    },

    menu(state) {
        return state.menu
    },

    getExpirationDate(state) {
        return state.expirationDate
    }

}

export default {
    state,
    mutations,
    actions,
    getters
}
